import classNames from 'classnames';
import type { ComponentProps } from 'react';

import { Button } from '@ctct/payflow-ui';

import './partnership-offer-card.scss';

import { ConnectedLogos } from './ConnectedLogos';
import { PartnershipOfferContent } from './PartnershipOfferContent';
import type { ConnectedLogoItem, TPartnershipOfferContent } from './types';

interface PartnershipOfferCardProps {
  className?: string;
  logos: ConnectedLogoItem[];
  heading: string;
  subheading: string;
  btnLabel: string;
  btnOnClick: () => void;
  content: TPartnershipOfferContent;
  btnVariant?: ComponentProps<typeof Button>['variant'];
}

export function PartnershipOfferCard({
  className,
  logos,
  heading,
  subheading,
  btnLabel,
  btnOnClick,
  content,
  btnVariant = 'white',
}: PartnershipOfferCardProps) {
  return (
    <div className={classNames('presentation-layer partnership-offer-card', className)}>
      <ConnectedLogos items={logos} />
      <div className="partnership-offer-card__heading-container">
        <span className="partnership-offer-card__subheading">{subheading}</span>
        <h3 className="partnership-offer-card__heading">{heading}</h3>
      </div>
      <div className="partnership-offer-card__button">
        <Button variant={btnVariant} size="small" onClick={btnOnClick}>
          {btnLabel}
        </Button>
      </div>
      <PartnershipOfferContent content={content} />
    </div>
  );
}
